<div>
  <div class="header-style">
    <div class="h-100">
      @if (user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) {
        <mat-form-field appearance="outline" class="select">
          <mat-select data-testid="usedOnMobile_filter" (selectionChange)="filterChange($event.value)" [(value)]="selected" #usedOnMobile_filter  id="usedOnMobile_filter"
            name="usedOnMobile_filter">
            <mat-option i18n="@@ReferencesUsedonmobile" value="usedOnMobile">References Used on mobile</mat-option>
            <mat-option i18n="@@ReferencesToPickFrom" value="manufacturer">References To Pick From</mat-option>
          </mat-select>
        </mat-form-field>
      }
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)"></mat-paginator>
      @if (user.type !== utils.userTypes.Admin) {
        <mat-icon data-testid="add_reference_button" (click)="openAddReference()" class="cursor add-icon" svgIcon="add" aria-hidden="false" i18n-label="@@addReference" aria-label="Add Reference"></mat-icon>
      }
      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input data-testid="references_search_input" i18n-placeholder="@@searchPlaceholder" matInput formControlName="search" id="search" placeholder="Search" name="search"/>
            <mat-icon data-testid="references_clear_button" class="cursor" matSuffix (click)="clearSearch()" i18n-label="@@clearSearch" aria-label="Clear Search">clear</mat-icon>
          </mat-form-field>
        }
      </form>
      <mat-icon data-testid="references_search_button" (click)="handleSearchClick()" class="cursor" svgIcon="search" aria-hidden="false" i18n-label="@@searchReferences" aria-label="Search References"></mat-icon>
    </div>
  </div>
  @for (item of referencesList; track item; let itemIndex = $index) {
    <mat-card class="simple-card cursor">
      <mat-card-content>
        <div class="flex-grow d-flex justify-content-between cursor">
          <div class="flex-grow" (click)="openReferenceDetails(item)">
            <div class="mat-subtitle-1 mb-12" matTooltip ellipsisTooltip>{{item.instituteName}}</div>
            <div class="mat-caption" matTooltip ellipsisTooltip>{{item.instituteDepartment}}</div>
          </div>
          @if (user.type === utils.userTypes.Manufacturer || user.type === utils.userTypes.ManufacturerChild) {
            <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-label="@@moreOptions" aria-label="More options">more_vert</mat-icon>
          }
          @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'manufacturer') {
            <mat-icon class="{{item.usedOnMobile ? 'cursor header-icon' : 'header-icon-color cursor'}}" (click)="item.usedOnMobile ? moveToNotUsedOnMobile(item.id) : moveToUsedOnMobile(item.id)" i18n-label="@@toggleUsedOnMobile" aria-label="Toggle Used On Mobile">stay_current_portrait</mat-icon>
          }
          @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'usedOnMobile' && item.isAddedByManufacturer === true) {
            <mat-icon class="cursor header-icon" (click)="moveToNotUsedOnMobile(item.id)" i18n-label="@@removeFromMobile" aria-label="Remove From Mobile">stay_current_portrait</mat-icon>
          }
          @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'usedOnMobile' && item.isAddedByManufacturer === false) {
            <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-label="@@moreOptions" aria-label="More options">more_vert</mat-icon>
          }
        </div>
        <mat-menu #menu="matMenu">
          <button i18n="@@edit" data-testid="edit_reference_button" (click)="editReference(item)" mat-menu-item>Edit</button>
          <button i18n="@@delete" data-testid="delete_reference_button" (click)="deleteReference(item.id)" mat-menu-item>Delete</button>
        </mat-menu>
      </mat-card-content>
    </mat-card>
  }
  @if (referencesList.length === 0) {
    <img class="empty-view-img" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" i18n-alt="@@emptyView" alt="No references available">
  }
</div>